module.exports = __webpack_public_path__ + "static/media/icon-signup.b27a85ca.png";